import React, { createContext, useContext } from "react";

const MembershipSuspensionFormContext = createContext(undefined);

export const MembershipSuspensionFormProvider = ({ children, value }) => {
	return <MembershipSuspensionFormContext.Provider value={value}>{children}</MembershipSuspensionFormContext.Provider>;
};

export const useMembershipSuspensionFormContext = () => {
	const context = useContext(MembershipSuspensionFormContext);

	if (context === undefined) {
		throw new Error("useMembershipSuspensionFormContext 必須在 MembershipSuspensionFormProvider 中使用");
	}

	return context;
};
